<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #plantName
                        [messages]="plantNameMessages"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [validators]="validators.name"
                        (inputValueChange)="plantNameInputChange($event)"
                        baseCypressTag="business-settings-spp-modal-plant-name"
                        label="Supplying packing plant name"
                        maxLength="100"
                        placeholder="Please, write a new supplying packing plant name"></app-input-text>
        <app-input-text #plantCode
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [messages]="plantCodeMessages"
                        [validators]="validators.sppCode"
                        (inputValueChange)="plantCodeInputChange($event)"
                        baseCypressTag="business-settings-spp-modal-plant-code"
                        label="Supplying packing plant code"
                        maxLength="4"
                        placeholder="Please, write a new supplying packing plant code, e.g. A167"></app-input-text>
        <app-input-text #plantNumber
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [messages]="plantNumberMessages"
                        [validators]="validators.sppNumber"
                        (inputValueChange)="plantNumberInputChange($event)"
                        baseCypressTag="business-settings-spp-modal-plant-number"
                        label="Supplying packing plant number"
                        maxLength="10"
                        placeholder="Please, write a new supplying packing plant number, e.g. 0084922938"></app-input-text>
        <app-input-dropdown #sapSystem
                            [warningLevel]="WarningsEnum.WARNING_SAVE"
                            [inputFormatter]="typeahead.inputTextNameFormatter"
                            [resultFormatter]="typeahead.inputTextNameFormatter"
                            [resultsFunction]="getInitialData"
                            (inputValueChange)="integrationChannelsInputChange($event)"
                            baseCypressTag="business-settings-spp-modal-sap-system"
                            class="business-settings-spp-modal-sap-system"
                            label="SAP System"
                            placeholder="Please, select a SAP system"></app-input-dropdown>
        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>
</app-generic-modal>
